import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { HorizontalTimeline, TimelineElement } from "../../generic/horizontal-timeline"
import { ProjetCreationWorkflow } from "../../../model/entities/projet-creation-workflow"
import { InfosGeneralesProjetForm } from "./infos-generales-projet-form"
import { referenceService } from "../../../services/reference-service"
import { AuthenticationState } from "../../../store/authentication/types"
import { ApplicationState } from "../../../store";
import { ProjetCreationWorkflowListResponse, ProjetDetailResponse } from "../../../model/dto/response"
import { DescriptionProjetForm } from "./description-projet-form"
import { FinancementGlobalForm } from "./financement-global-form"
import Projet from "../../../model/projet"
import { FinancmentParticipatifForm } from "./financement-participatif-form"
import { CagnotteForm } from "./cagnotte-form"
import { FinalisationProjetForm } from "./finalisation-projet-form"
import { ProjectInfos } from "../detail/project-detail"

type Props = {
    loginProps?: AuthenticationState,
    projet: Projet,
    onNextStep: (stepKey: string) => void
}

function CreateProjetWorkflowForm({loginProps, projet, onNextStep}: Props) {
    const [timelineElements, setTimelineElements] = useState<ProjetCreationWorkflow[]>([])
    const [activeStepKey, setActiveStepKey] = useState(ProjetCreationWorkflow.INFORMATIONS_GENERALES)
    const [currentProjet, setCurrentProjet] = useState<Projet>(projet)

    useEffect(() => {
        referenceService.getAllProjetCreationWorkflow(loginProps?.oauth)
        .then(response => {
            return response.json() as Promise<ProjetCreationWorkflowListResponse>
        })
        .then(response => {
            if(response.IsTraitementOk) {
                setTimelineElements(response.ProjetCreationWorkflowList!)
            }
        })

        setCurrentProjet(projet)
    }, [projet,])

    const onNextStepSuccess = (response: ProjetDetailResponse, nextStep: string) => {
        setActiveStepKey(nextStep)
        setCurrentProjet(response.Projet!)
        onNextStep(nextStep)
    }

    const goToNextStep = (stepKey: string) => {
        setActiveStepKey(stepKey)
        onNextStep(stepKey)
    }

    return (
        <>
            <HorizontalTimeline
                elements={timelineElements.map(element => {
                    return {
                        key: element.Code,
                        dataMainInfo: element.Libelle,
                        order: element.Ordre
                    } as TimelineElement
                })}
                activeElementKey={activeStepKey}
                lastElementKey={ProjetCreationWorkflow.FINALISATION}
            />
            {activeStepKey == ProjetCreationWorkflow.INFORMATIONS_GENERALES && (
                <InfosGeneralesProjetForm 
                    projet={currentProjet}
                    isCreating={true}
                    onSubmitSuccess={(response: Response) => {
                        onNextStepSuccess(response, ProjetCreationWorkflow.DESCRIPTION)
                    }}
                    skipStep={goToNextStep}
                />
            )}
            {activeStepKey == ProjetCreationWorkflow.DESCRIPTION && (
                <DescriptionProjetForm 
                    projet={currentProjet}
                    isCreating={true}
                    onSubmitSuccess={(response: Response) => {
                        onNextStepSuccess(response, ProjetCreationWorkflow.FINANCEMENT_GLOBAL)
                    }}
                    skipStep={goToNextStep}
                />
            )}
            {activeStepKey == ProjetCreationWorkflow.FINANCEMENT_GLOBAL && (
                <FinancementGlobalForm 
                    projet={currentProjet}
                    isCreating={true}
                    onSubmitSuccess={(response: Response) => {
                        onNextStepSuccess(response, ProjetCreationWorkflow.FINANCEMENT_PARTICIPATIF)
                    }}
                    skipStep={goToNextStep}
                />
            )}
            {activeStepKey == ProjetCreationWorkflow.FINANCEMENT_PARTICIPATIF && (
                <FinancmentParticipatifForm 
                    projet={currentProjet}
                    isCreating={true}
                    onSubmitSuccess={(response: Response) => {
                        onNextStepSuccess(response, ProjetCreationWorkflow.CAGNOTTE)
                    }}
                    skipStep={goToNextStep}
                />
            )}
            {activeStepKey == ProjetCreationWorkflow.CAGNOTTE && (
                <CagnotteForm 
                    projet={currentProjet}
                    isCreating={true}
                    onSubmitSuccess={(response: Response) => {
                        onNextStepSuccess(response, ProjetCreationWorkflow.FINALISATION)
                    }}
                    skipStep={goToNextStep}
                />
            )}
            {activeStepKey == ProjetCreationWorkflow.FINALISATION && (
                <FinalisationProjetForm 
                    projet={currentProjet}
                />
            )}
        </>
    )
}

const mapStateToProps = (state: ApplicationState) => ({
    loginProps: state.authentication
});

const ConnectedCreateProjetWorkflowForm = connect(mapStateToProps, null)(CreateProjetWorkflowForm);
export { ConnectedCreateProjetWorkflowForm as CreateProjetWorkflowForm };